import './styles.scss';

import { parse, stringify } from 'query-string';
import { StrictMode } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { ClerkProvider, RedirectToSignIn } from '@clerk/react';
import { setApiBaseUrl } from '@client/api';
import { addYupMethods } from '@client/toolkit';

import { Route, Routes } from 'react-router-dom';
import App from './app/app';
import { OnboardingApp } from './app/onboarding-app';
import { ClerkTokenBridge } from './components/ClerkTokenBridge';
import { config } from './config';
import { initI18n } from './i18n';
import { store } from './redux/store';
import { LicenseInfo } from '@mui/x-license';

addYupMethods();
setApiBaseUrl(config.apiUrl);
initI18n();
LicenseInfo.setLicenseKey(config.muiLicenseKey);

const root = ReactDOM.createRoot(document.getElementById(config.rootElementId) as HTMLElement);

root.render(
  <Provider store={store}>
    {/* @ts-expect-error ClerkProvider typing issue in v6 - publishableKey is supported at runtime */}
    <ClerkProvider publishableKey={config.clerkPublishableKey}>
      <ClerkTokenBridge />
      <StrictMode>
        <BrowserRouter basename={config.basename}>
          <QueryParamProvider
            adapter={ReactRouter6Adapter}
            options={{ searchStringToObject: parse, objectToSearchString: stringify }}
          >
            <DndProvider backend={HTML5Backend}>
              <Routes>
                <Route path="/onboarding/portfolio" element={<OnboardingApp />} />
                <Route path="*" element={<App />} />
              </Routes>
            </DndProvider>
          </QueryParamProvider>
        </BrowserRouter>
      </StrictMode>
    </ClerkProvider>
  </Provider>,
);
